// extracted by mini-css-extract-plugin
export default {"overlay":"Zy-z","bodyOpen":"_y-z","content":"az-z","header":"bz-z","close":"cz-z","closeNoHeading":"dz-z"};